import React, { createContext, useState, useContext, useEffect } from 'react';
import { login as loginService, getCurrentUser } from '../services/authService';
import { saveToken, removeToken, getToken } from '../utils/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = getToken();
      if (token) {
        try {
          const { user } = await getCurrentUser();
          setUser(user);
        } catch (error) {
          removeToken();
        }
      }
      setTimeout(() => {
        setLoading(false);
      }, 800);
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    const { token, user } = await loginService(email, password);
    saveToken(token);
    setUser(user);
    return { user };
  };

  const logout = () => {
    removeToken();
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
